module.exports = __webpack_public_path__ + "media/assets/avia/search/plane_purpl-f96c6856b54aa1e52f25376840416e65.png";